var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"bread",attrs:{"separator":"/"}},_vm._l((_vm.navs),function(item){return _c('el-breadcrumb-item',{key:item.path,attrs:{"to":{ path: item.path }}},[_vm._v(_vm._s(item.meta.title))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }